import styled from 'styled-components'

const StyledAllowanceArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 21px 25px 21px;
  .logo {
    margin-bottom: 5px;
    margin-top: 57.5px;
  }
`
const StyledAllowanceFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textTertiary};
  font-weight: 500;
  font-size: 15px;
  line-height: 13px;
  padding: 25px 0;
  box-shadow: inset 0px 1px 0px ${({ theme }) => theme.colors.borderDefault};
  margin-left: -21px;
  margin-right: -21px;
  width: 100%;
  .loading {
    width: 18px;
    height: 18px;
    animation: rotate 3s linear infinite;
    margin-right: 10px;
  }
`
const StyledTips = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  margin-top: 42.5px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .notice-info-logo {
    margin-left: 4px;
  }
`

const StyledInfo = styled.div`
  color: #5a5d6d;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`

const StyledApproveBtn = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 36px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  width: 100%;
  padding: 12px 28px;
  cursor: pointer;
  outline: none;
  border: none;
`
export {
  StyledAllowanceArea,
  StyledAllowanceFooter,
  StyledTips,
  StyledInfo,
  StyledApproveBtn,
}
